import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Paper, TextField, Typography } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import ImageProfileCircle from "../../components/ImageProfileCircle";
import { useEffect, useRef, useState } from "react";
import { AppDispatch, RootState } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { getPosts, setResetPost } from "../../store/slices/posts";
import { RecognitionData } from "../../interfaces/post.interface";
import { Delete as DeleteIcon } from '@mui/icons-material';
import { deletePostsRequest, setPostsRequest } from "../../api/employeePortal";
import MySnackbar from "../../components/MySnackbar";
import AddIcon from '@mui/icons-material/Add';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { searchCompanyEmployees } from "../../store/slices/userRequests";
import MyTextField from "../../components/MyTextField";

// import {ReactComponent as topImage} from '../../assets/images/posts/fast-actions-top-image.svg';
const topImage = require('../../assets/images/posts/fast-actions-top-image.svg').default;

interface RecognitionCardProps {
    hidenButton?: boolean;
    onlyList?: boolean;
}

const toCamelCase = (text: string): string => {
    return text
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};

const RecognitionCard = ({hidenButton, onlyList}: RecognitionCardProps) => {

    // const navigate = useNavigate();
    const debounceTimeoutRef = useRef<NodeJS.Timeout | null>(null);

    const dispatch = useDispatch<AppDispatch>();
    const {s10palette} = useTheme();

    const {companyselected, connectionId} = useSelector((state: RootState) => state.auth);
    const {recognitions} = useSelector((state: RootState) => state.posts);
    const { employees } = useSelector((state: RootState) => state.userRequests).companyEmployees;

    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [userIsAdmin, setUserIsAdmin] = useState(false);
    const [addDocument, setAddDocument] = useState(false);
    const [deleteDocument, setDeleteDocument] = useState<any | null>(null);
    const [errorMsg, setErrorMsg] = useState("");
    const [successMsg, setSuccessMsg] = useState("");
    const [inputText, setInputText] = useState("");
    const [inputValue, setInputValue] = useState("");


    useEffect(() => {
        if (!companyselected) return;
        const managementOption = companyselected?.Roles?.Access
                                    .find(m => m.Name === "Gestión");
        const hasAppoveOption = companyselected?.Roles?.Access
                                    .find(m => m.Name === "Publicaciones" && m.ParentId === managementOption?.SecurityAccessId);
        setUserIsAdmin(!!hasAppoveOption);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyselected]);

    useEffect(() => {
        if (!companyselected || !connectionId || recognitions.data || isLoading) return;
        setIsLoading(true)
        dispatch(getPosts({postType: "recognition",}))
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [connectionId]);

    useEffect(() => {
        if (!connectionId || !companyselected) {
            return;
        }
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }
        debounceTimeoutRef.current = setTimeout(() => {
            dispatch(searchCompanyEmployees(companyselected.RUC, 40, 1, inputValue));
        }, 250);
        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [connectionId, companyselected, inputValue]);

    const handleSavePost = async () => {
        if (!companyselected?.Token || loading) {
            return;
        }
        if (employees.length !== 1) {
            setErrorMsg("Debes seleccionar un colaborador.");
            return
        }
        
        setLoading(true)
        const result = await setPostsRequest(companyselected?.Token, {
            postType: "recognition",
            text: inputText,
            recognizedUserId: employees[0].CodIdentificador,
            recognizedUserName: employees[0].Descripcion,
        });
        if (result?.status === 200) {
            dispatch(setResetPost("recognition"));
            setSuccessMsg("El reconocimiento fue cargado con éxito")
            setInputText("");
            setInputValue("");
            setAddDocument(false);
            dispatch(getPosts({postType: "recognition",}));
        } else {
            console.log(result)
            setErrorMsg(result?.data?.message || "Ocurrio un error al publicar el reconocimiento, por favor reintenta")
        }
        setLoading(false)
    }

    const handleDeletePost = async () => {
        if (!companyselected?.Token || loading) {
            return;
        }
        setLoading(true)
        const result = await deletePostsRequest(deleteDocument);
        if (result?.status === 200) {
            dispatch(setResetPost("recognition"));
            setSuccessMsg("El documento fue eliminado con éxito")
            await dispatch(getPosts({postType: "recognition",}));
            setDeleteDocument(null);
        } else {
            console.log(result)
            setErrorMsg(result?.data?.message || "Ocurrio un error al eliminar el documento, por favor reintenta")
        }
        setLoading(false)
    }

    if (!onlyList && !userIsAdmin && !recognitions?.data?.length) {
        return <></>
    }

    return (<Paper 
        elevation={3}
        style={{
            width: "100%", 
            borderRadius: "0.5rem",
        }}
    >
        {!onlyList && <Grid item style={{width: "100%", borderRadius: "0.5rem",}}>
            <img 
                style={{
                    width: "100%",
                }}
                src={topImage} 
                alt="quick access"
            />
        </Grid>}
        <Grid style={{padding: `${onlyList ? ".5" : "0"}rem 1rem 1rem 1rem`, width: "100%"}}>
            <Grid item>
                <Typography variant="h6" style={{marginTop: "1rem"}}>
                    Reconocimientos
                </Typography>
            </Grid>
            {(recognitions.data as RecognitionData[])?.map((recog) => (
                <Grid
                    key={recog["orderTimestamp-ID"]}
                    container
                    item
                    style={{
                        marginTop: "1rem",
                        width: "100%",
                        position: "relative",
                    }}
                    direction={"row"}
                >
                    {userIsAdmin && <IconButton
                        style={{
                            position: "absolute",
                            top: 0,
                            right: 0,
                            padding: "0.25rem",
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            setDeleteDocument(recog);
                        }}
                    >
                        <DeleteIcon 
                            color="error"
                            style={{ cursor: 'pointer', fontSize: '1.1rem' }}
                        />
                    </IconButton>}

                    <ImageProfileCircle
                        width="2.5rem"
                        height="2.5rem"
                        ruc={recog.ruc}
                        userId={recog.recognizedUserId}
                        userName={recog.recognizedUserName}
                    />

                    <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="flex-start"
                        item
                        style={{
                            flex: 1,
                            width: "100%",
                            marginLeft: ".5rem",
                        }}
                    >
                        <Typography variant="subtitle2" color={s10palette.S10Greygrey700}>
                            {toCamelCase(recog.recognizedUserName)}
                        </Typography>
                        <Typography variant="subtitle1" fontSize={"0.75rem"} color={s10palette.S10Greygrey500}>
                            {recog.text}
                        </Typography>
                    </Grid>
                </Grid>
            ))}
            {userIsAdmin && 
                <Grid
                    container
                    direction="column"
                    width="100%"
                    alignContent="end"
                >
                    <Grid item style={{marginTop: "1rem"}}>
                        <Button 
                            style={{
                                backgroundColor: "white",
                                color: s10palette.S10Blueblue600
                            }}
                            variant="contained"
                            endIcon={<AddIcon />}
                            onClick={() => setAddDocument(true)}
                        >
                            Agregar
                        </Button>
                    </Grid>
                </Grid>
            }
            {/*!hidenButton && <Grid item style={{width: "100%", marginTop: "1.5rem"}}>
                <Button 
                    fullWidth 
                    variant="contained"
                    style={{
                        height: "2.5rem",
                        backgroundColor: s10palette.S10Blueblue50,
                        color: s10palette.S10Blueblue600,
                        fontSize: "0.875rem",
                        padding: "1rem"
                    }}
                    disableElevation
                    // TODO: define recognitions path
                    onClick={() => navigate('/')}
                >
                    Ver más **
                </Button>
            </Grid>*/}
        </Grid>
        {userIsAdmin && addDocument && 
            <Dialog
                open={addDocument}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle
                    id="responsive-dialog-title" 
                    style={{textAlign: "center"}} 
                    variant="h5"
                >
                    Agregar reconocimiento
                </DialogTitle>
                <DialogContent style={{width: "100%", height: "50%", padding: "0 1.5rem", }}>
                    <MyTextField
                        placeholder="Descripción del reconocimiento"
                        onChange={({target}) => setInputText(target.value)}
                        value={inputText}
                    />
                    <Autocomplete
                        freeSolo
                        options={employees} // Opciones cargadas desde la API
                        getOptionLabel={(option: any) => option.Descripcion || ""} // Campo a mostrar
                        loading={loading}
                        inputValue={inputValue}
                        size="small"
                        style={{
                            marginTop: ".5rem"
                        }}
                        onInputChange={(event, value) => {
                            console.log(value)
                            setInputValue(value)}
                        }
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                placeholder="Colaborador"
                                variant="outlined"
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                    <>
                                        
                                        {params.InputProps.endAdornment}
                                    </>
                                    ),
                                }}
                            />
                        )}
                    />
                </DialogContent>
                <DialogActions>
                    <Grid container direction="row" marginTop="1rem">
                    <Grid item xs={6}>
                        <Button 
                            variant="outlined" 
                            style={{width: "8rem", margin: ".5rem",}}
                            startIcon={<CloseIcon style={{height: "1rem"}} />}
                            onClick={() => setAddDocument(false)}
                        >
                            Cancelar
                        </Button>
                    </Grid>
                    <Grid item xs={6} textAlign={"right"}>
                        <Button
                            variant="contained" 
                            style={{width: "8rem", margin: ".5rem",}}
                            startIcon={<CheckIcon style={{height: "1rem"}} />}
                            onClick={handleSavePost}
                            disabled={loading || !inputText}
                        >
                            Aceptar
                        </Button>
                    </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        }
        {userIsAdmin && deleteDocument && 
            <Dialog
                open={!!deleteDocument}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle
                    id="responsive-dialog-title" 
                    style={{textAlign: "center"}} 
                    variant="h5"
                >
                    ¿Seguro de eliminar el reconocimiento seleccionado?
                </DialogTitle>
                <DialogContent style={{width: "100%", height: "50%", padding: "0 1.5rem", }}>
                    Estas a punto de eliminar el reconocimiento "{deleteDocument.text}"
                </DialogContent>
                <DialogActions>
                    <Grid container direction="row" marginTop="1rem">
                    <Grid item xs={6}>
                        <Button 
                            variant="outlined" 
                            style={{width: "8rem", margin: ".5rem",}}
                            startIcon={<CloseIcon style={{height: "1rem"}} />}
                            onClick={() => setDeleteDocument(null)}
                        >
                            Cancelar
                        </Button>
                    </Grid>
                    <Grid item xs={6} textAlign={"right"}>
                        <Button
                            variant="contained" 
                            style={{width: "8rem", margin: ".5rem",}}
                            startIcon={<CheckIcon style={{height: "1rem"}} />}
                            onClick={handleDeletePost}
                            disabled={loading}
                        >
                            Aceptar
                        </Button>
                    </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        }
        <MySnackbar
            open={!!errorMsg}
            msg={errorMsg}
            severity="error"
            onClose={() => setErrorMsg("")}
        />
        <MySnackbar
            open={!!successMsg}
            msg={successMsg}
            severity="success"
            onClose={() => setSuccessMsg("")}
        />
    </Paper>)
}

export default RecognitionCard;